const Masonry = require('masonry-layout');

export default class Cases {
    tagButtonEl = '.js-cases-tag';
    selectEl = '.js-cases-select';
    itemsEl = '.js-cases-items';
    itemEl = '.js-cases-item';

    tagsBusiness = [
        'banks',
        'credit',
        'internet',
        'fintech'];
    tagsSolution = [
        'internet-acquiring',
        'online-credit',
        'fintegrate',
        'sepadd',
        'smartpos',
        'smartwallet',
        'flymoney',
        'dengisend',
        'agp',
        'mobile-commerce',
        'poscredit'];

    selectedBusiness = [];
    selectedSolution = [];

    init = () => {
        this.tagButton.on('click', this.onTagClick);
        this.tagSelect.on('change', this.onSelectClick);

        $(window).on('resize', () => {
            this.msnry.layout();
        });
    }

    onSelectClick = (e) => {
        const target = $(e.currentTarget);

        let tag = target.val();
        let type = target.data('type');
        this.onTagSelect(type, tag);
    }

    onTagClick = (e) => {
        const target = $(e.currentTarget);
        let tag;
        let type;

        this.tagButton.removeClass('active');
        target.addClass('active');

        if (target.data('type-business')){
            tag = target.data('type-business');
            type = 'business';
        }

        if (target.data('type-solution')){
            tag = target.data('type-solution');
            type = 'solution';
        }

        this.onTagSelect(type, tag);
    }

    showAllBusiness = () => {
        this.tagsBusiness.forEach(item => {
            $(`.${item}`).addClass('active');
            $(`[data-type-business="${item}"]`).removeClass('active');
        });
        $(`[data-type-business="all"]`).addClass('active');
        $(`[data-type-solution="all"]`).addClass('active');
        this.msnry.layout();
    }

    showAllSolution = () => {
        this.tagsSolution.forEach(item => {
            $(`.${item}`).addClass('active');
            $(`[data-type-solution="${item}"]`).removeClass('active');
        });
        $(`[data-type-solution="all"]`).addClass('active');
        $(`[data-type-business="all"]`).addClass('active');
        this.msnry.layout();
    }

    addTagSelected = (type, tag) => {
        if (type === 'business'){
            let index;
            console.log(this.selectedBusiness);
            if (this.selectedBusiness.includes(tag) ){
                index = this.selectedBusiness.indexOf(tag);
                this.selectedBusiness.splice(index, 1);
                $(`[data-type-${type}="${tag}"]`).removeClass('active')
            }else {
                $(`[data-type-${type}="${tag}"]`).addClass('active')
                this.selectedBusiness.push(tag);
            }
        }

        if (type === 'solution'){
            let index;
            if (this.selectedSolution.includes(tag)) {
                index = this.selectedSolution.indexOf(tag)
                this.selectedSolution.splice(index, 1);
                $(`[data-type-${type}="${tag}"]`).removeClass('active')
            }else {
                $(`[data-type-${type}="${tag}"]`).addClass('active')
                this.selectedSolution.push(tag);
            }
        }
    }

    onTagSelect = (type, tag) => {
        if (tag === 'all' && type === 'solution'){
            this.showAllSolution();
            return;
        }else if (tag === 'all' && type === 'business') {
            this.showAllBusiness();
            return;
        }
        // @todo Make it for business and solution separately
        if (type === 'business'){
            this.selectTagBusiness(tag);
        }

        if (type === 'solution'){
            this.selectTagSolution(tag);
        }

        this.msnry.layout();

        // this.items.each((index, item) => {

        //     if (businessTags.includes(tag) || solutionTags.includes(tag)){
        //         $(item).addClass('active');
        //     }else {
        //         $(item).removeClass('active');
        //     }
        // });
    }

    selectTagBusiness = (tag) => {
        $('[data-type-business="all"]').removeClass('active');
        if (!$('[data-type-solution="all"]').hasClass('active')){
            this.tagsSolution.forEach(item => {
                $(`.${item}`).removeClass('active');
            });
            $('[data-type-solution="all"]').addClass('active');
        }
        $('[data-type="solution"]')[0].sumo.selectItem('all');

        this.tagsBusiness.forEach(item => {
            $(`.${item}`).removeClass('active');
        });
        $(`.${tag}`).addClass('active');
        // this.selectedBusiness.forEach((item) => {

        // });
    }

    selectTagSolution = (tag) => {
        console.log(tag);
        $('[data-type-business="all"]').removeClass('active');

        if (!$('[data-type-business="all"]').hasClass('active')){
            this.tagsBusiness.forEach(item => {
                $(`.${item}`).removeClass('active');
            });
            $('[data-type-business="all"]').addClass('active');
        }

        $('[data-type="business"]')[0].sumo.selectItem('all');

        this.tagsSolution.forEach(item => {
            $(`.${item}`).removeClass('active');
        });

        // this.selectedSolution.forEach((item) => {
        //     $(`.${item}`).addClass('active');
        // });
        $(`.${tag}`).addClass('active');
    }

    constructor(node) {
        this.node = $(node);

        this.tagButton = $(this.tagButtonEl);
        this.tagSelect = $(this.selectEl);
        this.items = this.node.find(this.itemEl);

        this.msnry = new Masonry( this.itemsEl, {
            itemSelector: this.itemEl,
        });

        this.showAllBusiness();
        this.showAllSolution();

        this.init();
    }
}



// WEBPACK FOOTER //
// ./app/blocks/cases/cases.js